
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'EmailBadge',

  props: {
    email: {
      type: String,
      required: true,
    },
  },
});
